type Now = {
    (): number,
    last: number | undefined,
};

const now = function () {
    const time = Date.now();
    const last = now.last || time;
    return now.last = time > last ? time : last + 1;
} as Now;

/**
 * Generates a unique string ID by combining an optional prefix with a monotonically
 * increasing timestamp.
 *
 * The timestamp is derived from `Date.now()` but is guaranteed to be strictly
 * increasing — if two calls happen within the same millisecond, the second call
 * returns `previousTimestamp + 1` rather than a duplicate value. This makes the
 * IDs safe to use for DOM element IDs, React keys, and ARIA attribute values
 * within a single browser session.
 *
 * @param prefix - String prepended to the numeric timestamp. Defaults to `'id'`.
 * @returns A unique string of the form `"{prefix}{timestamp}"`, e.g. `"id1712345678901"`.
 *
 * @example
 * ```ts
 * uniqId();          // → "id1712345678901"
 * uniqId('label-'); // → "label-1712345678902"
 * ```
 */
export function uniqId(prefix = 'id') {
    return `${prefix}${now()}`;
}
